module.exports = __webpack_public_path__ + "img/ENERGIEDICI.00306f00.png";